import { useEffect } from 'react';
import * as Redux from 'redux';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducer from './Reducers';
import { createLogger } from 'redux-logger';
import ContainerApp from './Containers/ContainerApp';
import { BrowserRouter } from 'react-router-dom';
import wowsEntities from '@wg/wows-entities';

import './styles/global.scss';
import '@wg/wows-css-uikit/index.css';
import '@wg/wows-entities/index.css';
import '@wg/wows-common-footer/style.css';
import { settings } from './helpers/utils';
import { TooltipProvider } from '@wg/wows-react-uikit';
import { WarmingUpCollections } from '@wg/wows-entities/const';

const middleware: Redux.Middleware[] = [thunk];

if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger());
}

export const store = createStore(reducer, applyMiddleware(...middleware));

const App = () => {
    useEffect(() => {
        wowsEntities.init({
            vortexBaseUrl: window.catalogue.urls.vortex,
            languageCode: settings.languageCode,
        }).then(() => {
            wowsEntities.warmingUp([WarmingUpCollections.rarity, WarmingUpCollections.vehicles, WarmingUpCollections.items]);
        });
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <TooltipProvider>
                    <ContainerApp />
                </TooltipProvider>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
